var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaycast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.073v2.92l-7-7 1.46-1.46L7 19.076v-.002zm2.921 2.92H7l7 7 1.46-1.46-5.539-5.54zm16.614-5.537l1.461-1.462-14-14-1.458 1.466 5.539 5.538H14.73L10.864 4.14 9.404 5.6l2.405 2.404h-1.68V18.87h10.865v-1.68l2.405 2.404 1.46-1.46-3.865-3.866V10.92l5.541 5.535zM7.73 7.27L6.265 8.732l1.568 1.566 1.461-1.46L7.73 7.27zm12.432 12.432l-1.46 1.462 1.566 1.568 1.462-1.462-1.568-1.568zM4.596 10.404l-1.462 1.462L7 15.732v-2.923l-2.404-2.405zM16.192 22h-2.924l3.866 3.866 1.462-1.462L16.192 22z",
    fill: "#FF6363"
  })));
}
export default SvgRaycast;